export * from './main';
export * from './constants';

import * as Constants from './constants';

export const CUBA = Constants.CUB;
export const IRAN = Constants.IRN;
export const IRAQ = Constants.IRQ;
export const NORTH_KOREA = Constants.PRK;
export const PHILIPPINES = Constants.PHL;
export const SINGAPORE = Constants.SGP;
export const SYRIA = Constants.SYR;
